module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_7016.f593a9b9.png";